import React from 'react';
import { useUser } from 'src/auth/UserContext';
import { AppDataProvider } from 'src/components/AppDataContext';
import { isTokenValid } from './tokenUtils';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { platformUser } = useUser();

  if (platformUser === null && isTokenValid()) {
    return <div>Loading session...</div>;
  }

  return <AppDataProvider>{children}</AppDataProvider>;
};

export default PrivateRoute;
